export default __webpack_public_path__ + "static/media/ThinOptics.37de73a1.svg";